"use client"

import { Link, useLocation } from "react-router-dom"
import {
  FiBarChart2,
  FiBookOpen,
  FiBriefcase,
  FiCreditCard,
  FiEdit3,
  FiFileText,
  FiHome,
  FiLayers,
  FiMessageSquare,
  FiSettings,
  FiShuffle,
  FiUploadCloud,
  FiUser,
  FiUserPlus,
  FiUsers,
} from "react-icons/fi"
import "./sidebar.css"

const iconMap = {
  dashboard: <FiHome size={18} />,
  tickets: <FiBriefcase size={18} />,
  inquiries: <FiMessageSquare size={18} />,
  help: <FiBookOpen size={18} />,
  profile: <FiUser size={18} />,
  upload: <FiUploadCloud size={18} />,
  update: <FiEdit3 size={18} />,
  reports: <FiBarChart2 size={18} />,
  addStaff: <FiUserPlus size={18} />,
  allStaff: <FiUsers size={18} />,
  setup: <FiSettings size={18} />,
  status: <FiLayers size={18} />,
  switch: <FiShuffle size={18} />,
  client: <FiCreditCard size={18} />,
  clients: <FiFileText size={18} />,
}

const Sidebar = ({ role, agentMenuVisibility = {} }) => {
  const location = useLocation()
  const { showTickets = true, showInquiries = true } = agentMenuVisibility

  const isActive = (path) => location.pathname.startsWith(path)

  const itemClassName = (active) =>
    `sidebar-link ${active ? "sidebar-link-active" : ""}`

  const Item = ({ to, iconKey, label }) => (
    <Link to={to} className={itemClassName(isActive(to))}>
      <span className="sidebar-link-icon">{iconMap[iconKey]}</span>
      <span className="sidebar-link-label">{label}</span>
    </Link>
  )

  return (
    <aside className={`app-sidebar ${role === "agent" ? "app-sidebar-agent" : ""}`}>
      <div className="sidebar-links">
        {role === "ticketbot-admin" && (
          <>
            <Item to="/admin" iconKey="dashboard" label="Dashboard" />
            <Item to="/admin/components/TicketAdmin" iconKey="tickets" label="Tickets" />
            <Item to="/admin/components/UploadExcel" iconKey="upload" label="Upload Data" />
            <Item to="/admin/components/UpdateRecords" iconKey="update" label="Update Records" />
            <Item to="/admin/components/subscription-management" iconKey="reports" label="Reports" />
            <Item to="/admin/components/add-staff" iconKey="addStaff" label="Add Staff" />
            <Item to="/admin/components/all-staff" iconKey="allStaff" label="Manage Staff" />
            <div className="sidebar-divider" />
            <Item to="/admin/components/Inquires" iconKey="inquiries" label="Inquiry Dashboard" />
            <Item to="/admin/components/set-bot-levels" iconKey="setup" label="Setup Your Bot" />
            <Item to="/admin/components/LeadStatus" iconKey="status" label="Lead Status" />
            <Item to="/admin/components/update-options" iconKey="switch" label="Update Bot Options" />
          </>
        )}

        {role === "leadbot-admin" && (
          <>
            <Item to="/admin/components/Inquires" iconKey="inquiries" label="Inquiry Dashboard" />
            <Item to="/admin/components/set-bot-levels" iconKey="setup" label="Setup Your Bot" />
            <Item to="/admin/components/LeadStatus" iconKey="status" label="Lead Status" />
            <Item to="/admin/components/update-options" iconKey="switch" label="Update Bot Options" />
            <div className="sidebar-divider" />
            <Item to="/admin/components/add-staff" iconKey="addStaff" label="Add Staff" />
            <Item to="/admin/components/all-staff" iconKey="allStaff" label="Manage Staff" />
          </>
        )}

        {role === "client-admin" && (
          <>
            <Item to="/client-admin" iconKey="dashboard" label="Dashboard" />
            <Item to="/admin/components/TicketAdmin" iconKey="tickets" label="Tickets" />
            <Item to="/admin/components/subscription-management" iconKey="reports" label="Reports" />
            <Item to="/admin/components/Inquires" iconKey="inquiries" label="Inquiries" />
          </>
        )}

        {role === "agent" && (
          <>
            <Item to="/agent" iconKey="dashboard" label="Dashboard" />
            {showTickets && <Item to="/agent/components/Tickets" iconKey="tickets" label="Tickets" />}
            {showInquiries && <Item to="/agent/components/Inquiries" iconKey="inquiries" label="Inquiries" />}
            <Item to="/agent/components/Help" iconKey="help" label="Help" />
            <Item to="/agent/components/ManageProfile" iconKey="profile" label="Profile" />
          </>
        )}

        {role === "superadmin" && (
          <>
            <Item to="/superadmin" iconKey="dashboard" label="Dashboard" />
            <Item to="/superadmin/components/add-client" iconKey="client" label="Add Client" />
            <Item to="/superadmin/components/all-client" iconKey="clients" label="All Client" />
          </>
        )}
      </div>
    </aside>
  )
}

export default Sidebar
